import { gql } from "@apollo/client";

export const GET_ONCOLOGISTS = gql`
  query getOncologists {
    oncologists {
      id
      name
      surname
      studies
      photo
      feedbackAvg
      surname
      policy_number
      role
      bio
      skills {
        name
      }
      feedbacksManual {
        id
        vote
        comment
        created_at
        patient_name
      }
      feedbacks {
        id
        professionist
        comment
        updated_at
        patient {
          name
        }
      }
    }
  }
`;

export const GET_ONCOLOGISTS_SEARCH = gql`
  query getOncologistsSearch($surname: String, $skills: [String!]) {
    skills {
      name
    }
    oncologistsSearch(surname: $surname, skills: $skills) {
      id
      name
      surname
      photo
      studies
      feedbackAvg
      role
      skills {
        name
      }
      feedbacksManual {
        id
        vote
        comment
        created_at
        patient_name
      }
      feedbacks {
        id
        professionist
        comment
        updated_at
        patient {
          name
        }
      }
    }
  }
`;

export const REGISTER_AND_BOOK_APPOINTMENT = gql`
  mutation RegisterAndBookAppointment(
    $name: String!
    $surname: String!
    $email: String!
    $password: String!
    $birth_date: Date!
    $birthPlace: String!
    $phone: String
    $gender: Gender
    $address: String!
    $cap: String!
    $city: String!
    $province: String!
    $codFisc: String!
    $professionistId: Int!
    $startAt: DateTime!
    $tesseraSanitariaAuth: Boolean!
  ) {
    registerAndBookAppointment(
      name: $name
      surname: $surname
      email: $email
      password: $password
      birthDate: $birth_date
      birthPlace: $birthPlace
      phone: $phone
      gender: $gender
      address: $address
      cap: $cap
      city: $city
      province: $province
      codFisc: $codFisc
      professionist_id: $professionistId
      start_at: $startAt
      tessera_sanitaria_auth: $tesseraSanitariaAuth
    ) {
      email
      appointments {
        id
        start_at
        oncologist {
          id
          name
          surname
          photo
          alboRegion {
              id
              name
          }
          albo_number
          policy_number
        }
        nutrizionist {
          id
          name
          surname
          photo
          alboRegion {
              id
              name
          }
          albo_number
          policy_number
        }
        has_patient_confirmed
        is_paid
        motivation
      }
    }
  }
`;
